/**
 * Helper utility to check if AI features are enabled
 * AI features are enabled if:
 * 1. kiosk.config_v2.aiKiosk === true
 * AI features are disabled if:
 * 1. kiosk object doesn't exist in localStorage
 * 2. config_v2 property doesn't exist
 * 3. aiKiosk property doesn't exist or is false
 */
export function isAIEnabled(): boolean {
    try {
        const kioskStr = window.localStorage.getItem('kiosk');
        
        // If kiosk object doesn't exist, disable AI
        if (!kioskStr) {
            //console.log('AI features disabled - kiosk object not found');
            return false;
        }
        
        const kiosk = JSON.parse(kioskStr);
        
        // If config_v2 property doesn't exist, disable AI
        if (!kiosk.config_v2) {
            //console.log('AI features disabled - config_v2 not found');
            return false;
        }
        
        const config = JSON.parse(kiosk.config_v2);
        
        // If aiKiosk property doesn't exist or is not true, disable AI
        if (config.aiKiosk !== true) {
            //console.log('AI features disabled - aiKiosk is', config.aiKiosk);
            return false;
        }
        
        // aiKiosk is true, enable AI
        //console.log('AI features enabled - aiKiosk is true');
        return true;
    } catch (error) {
        console.error('Error checking AI features flag:', error);
        // On error, disable AI for safety
        return false;
    }
}
